<template>
  <v-content class="experience-organization page">
    <can I="read" a="ExperienceOrganization">
      <v-container>
        <v-toolbar flat class="transparent">
          <v-breadcrumbs
            class="pl-0"
            :items="[
              { exact: true, text: 'Admin', to: '/dashboard' },
              { exact: true, text: 'Experience Organizations', to: '/experience_organizations' },
              {
                exact: true,
                text: id,
                to: `/experience_organizations/${id}`,
              },
            ]"
          >
            <v-icon slot="divider">mdi-chevron-right</v-icon>
          </v-breadcrumbs>

          <v-spacer />

          <v-btn small flat fab @click="refresh">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <CopyButton />
        </v-toolbar>
        <can I="create" a="ExperienceOrganization" v-if="adding">
          <CreateExperienceOrganization @done="refresh" @cancel="cancel" />
        </can>
        <can I="edit" a="ExperienceOrganization" v-else-if="editing && experienceOrganization">
          <EditExperienceOrganization
            :value="experienceOrganization"
            @refresh="refresh"
            @update="update"
            @cancel="cancel"
          />
        </can>
        <ShowExperienceOrganization
          v-else
          @refresh="refresh"
          @destroy="destroy"
          @edit="editing = true"
        />
      </v-container>
    </can>
  </v-content>
</template>

<script>
// Components
import CreateExperienceOrganization from '@/components/experience_organizations/Create'
import EditExperienceOrganization from '@/components/experience_organizations/Edit'
import ShowExperienceOrganization from '@/components/experience_organizations/Show'

// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  name: 'ExperienceOrganizationPage',

  components: {
    CreateExperienceOrganization,
    EditExperienceOrganization,
    ShowExperienceOrganization,
  },

  created() {
    if (typeof this.id === 'string' && this.id.toLowerCase() === 'new') this.adding = true
    if (typeof this.id === 'number' && this.id > 0) {
      this.$store.dispatch('admin/experience_organizations/fetch', this.id)
    }
  },

  props: {
    id: { type: [String, Number] },
  },

  data() {
    return { adding: false, editing: false }
  },

  computed: {
    ...mapGetters({
      experienceOrganization: 'admin/experience_organizations/find',
    }),
  },

  methods: {
    refresh() {
      return this.$store.dispatch('admin/experience_organizations/fetch', this.id)
    },

    cancel() {
      this.refresh().then(() => (this.editing = false))
    },

    update(value) {
      this.$store.dispatch('admin/experience_organizations/update', value).then(
        () => {
          this.$store.dispatch('snackbarSuccess', 'Saved')
          this.editing = false
        },

        () => this.$store.dispatch('snackbarError', 'Could not save Experience Organzation')
      )
    },

    destroy() {
      this.$store.dispatch('admin/experience_organizations/destroy', this.id).then(
        () => {
          this.$store.dispatch('snackbarSuccess', 'Experience Organzation Deleted')
          this.$router.push('/experience_organizations')
        },
        () => this.$store.dispatch('snackbarError', 'Could not delete Experience Organzation')
      )
    },
  },
}
</script>
